export function DataListItem({ title, description }) {
  return (
    <div className="flex flex-row space-x-2">
      <dt className="block text-gray-400">{title}:</dt>
      <dd className="block text-primary">{description}</dd>
    </div>
  );
}

export function DataList({ children, items = {} }) {
  return (
    <dl>
      {children
        ? children
        : Object.entries(items).map(([key, value]) => (
            <DataListItem key={key} title={key} description={value} />
          ))}
    </dl>
  );
}
